// extracted by mini-css-extract-plugin
export default {"articleTitle":"noticeArtice_articleTitle__jpAf1","content":"noticeArtice_content__WRqBy"};